import React, { useEffect, useState } from "react";
import { createRoutesFromChildren, useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
// import './Styles.css'; // Ensure styling is consistent with the app
import './RegistrationComplete.css';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Util from './ait/Util.js';


const VerifyLink = () => {
  const [searchParams] = useSearchParams();
  const [verificationStatus, setVerificationStatus] = useState(null); // null, "success", or "error"
  const [loading, setLoading] = useState(true); // Show a loading spinner while verifying

  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {

    

    console.log("token: "+token);

    if (token) {
      // Simulate a backend call to verify the token
      verifyToken(token)
        .then((response) => {
          if (response.valid) {
            setVerificationStatus("success");
          } else {
            setVerificationStatus("error");
          }
        })
        .catch(() => {
          setVerificationStatus("error");
        })
        .finally(() => {
          setLoading(false); // Hide the spinner once verification is complete
        });
    } else {
      setVerificationStatus("error");
      setLoading(false);
    }
  }, [searchParams]);

  
  // Dummy backend verification function
  const verifyToken = async (token) => {

    const command = Util.serverName + "/api/verifyEmail"; // Base API endpoint

      // Make the API call using POST method with a JSON body
    try
    {    
      const response = await fetch(command, {
          method: 'POST', // Use POST method
          headers: { 'Content-Type': 'application/json' }, // Specify JSON format
          body: JSON.stringify({link:token }), // JSON payload
        })
      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        throw new Error(data.message || 'Something went wrong');
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        throw new Error(data.message);
      }

      return { valid: true };
       
    }
    catch(error)
    {
      Swal.fire({
        title: 'Info',
        text: error.message,
        icon: 'info',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,    
      });        
      return { valid: false };
    }
  }

  const handleVerified = () => {
    // Simulate email verification success
    navigate("/email-verified");
  };

  return (    
      <div className="registration-complete-container">
        <div className="registration-complete-content">
          {verificationStatus === "success"  ? (
            <>
              <h1 className="registration-complete-title">Email Verification Successful</h1>
              <p className="registration-complete-message">
                Your email has been successfully verified. Please Login again or return to where you started the registration process and proceed.
              </p>
              <button className="login-button" onClick={() => window.location.href = '/login'}>
                  Login
              </button>
            </>
          ) : (
            <>
              <h1 className="registration-complete-title">Verification Failed</h1>
              <p className="registration-complete-message">
                Unfortunately, we were unable to verify your email. Please Login again and resend the verification email.
              </p>
              <button className="login-button" onClick={() => window.location.href = '/login'}>
                  Login
              </button>
            </>
          )}
        </div>
      </div>
    );

    /*
    <div className="app-container">
      {loading ? (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      ) : verificationStatus === "success" ? (
        <div className="verification-message success">
          <h1>Verification Successful</h1>          
          <p>Your email has been successfully verified. If you have an open window, you may proceed there, or click below to continue."</p>
          <button onClick={handleVerified}>Proceed</button>
        </div>
      ) : (
        <div className="verification-message error">
          <h1>Verification Failed</h1>
          <p>The verification link is invalid or has expired. If you have an open window, you may proceed there or generate another link by clicking below</p>
          <button onClick={() => alert("Verification email resent!")}>Resend Email</button>
        </div>
      )}
    </div>
  );
  */
};

export default VerifyLink;
